import template from './component.tpl.html';
import AlUserGridEntryController from './controller';

angular
    .module('festzelt-os.modules.guestlists')
    .component('alUserGridEntry', {
        bindings: {
            user: '<',
            onTriggerReload: '&'
        },
        controller: AlUserGridEntryController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/users/components/al-users-grid-view/sub-components/al-user-grid-entry/component.js